(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.peel-card').forEach((card) => {
    const ringEls = card.querySelectorAll('.ring-fill');

    function openCard(){
      if (card.classList.contains('is-open')) return;
      card.classList.add('is-open');
      card.setAttribute('aria-expanded', 'true');

      if (!reduceMotion){
        card.classList.add('is-dripping');
        setTimeout(() => card.classList.remove('is-dripping'), 750);
      }

      setTimeout(() => {
        ringEls.forEach((ring) => {
          const rda = parseFloat(ring.closest('.ring-svg')?.dataset.rda || ring.dataset.rda || 0);
          const circumference = 113.1;
          const offset = circumference - (circumference * Math.min(rda, 100) / 100);
          ring.style.strokeDashoffset = offset;
        });
      }, 400);
    }

    function closeCard(){
      card.classList.remove('is-open');
      card.setAttribute('aria-expanded', 'false');
    }

    card.addEventListener('click', () => {
      card.classList.contains('is-open') ? closeCard() : openCard();
    });

    card.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' '){
        e.preventDefault();
        card.classList.contains('is-open') ? closeCard() : openCard();
      }
    });
  });
})();